/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { DeleteConnectionMutationResponse, DeleteConnectionPathParams } from "../models/DeleteConnection";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { deleteConnection } from "../axios/deleteConnection";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteConnectionMutationKey = () => ["social-export-api", { url: '/connections/:station/:platform' }] as const

export type DeleteConnectionMutationKey = ReturnType<typeof deleteConnectionMutationKey>

export function deleteConnectionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = deleteConnectionMutationKey()
        return mutationOptions<DeleteConnectionMutationResponse, ResponseErrorConfig<Error>, {station: DeleteConnectionPathParams["station"], platform: DeleteConnectionPathParams["platform"]}, TContext>({
          mutationKey,
          mutationFn: async({ station, platform }) => {
            return deleteConnection(station, platform, config)
          },
        })

}

/**
 * @summary Delete station connection
 * {@link /connections/:station/:platform}
 */
export function useDeleteConnection<TContext>(options: 
{
  mutation?: UseMutationOptions<DeleteConnectionMutationResponse, ResponseErrorConfig<Error>, {station: DeleteConnectionPathParams["station"], platform: DeleteConnectionPathParams["platform"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? deleteConnectionMutationKey()

          const baseOptions = deleteConnectionMutationOptions(config) as UseMutationOptions<DeleteConnectionMutationResponse, ResponseErrorConfig<Error>, {station: DeleteConnectionPathParams["station"], platform: DeleteConnectionPathParams["platform"]}, TContext>
          

          return useMutation<DeleteConnectionMutationResponse, ResponseErrorConfig<Error>, {station: DeleteConnectionPathParams["station"], platform: DeleteConnectionPathParams["platform"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<DeleteConnectionMutationResponse, ResponseErrorConfig<Error>, {station: DeleteConnectionPathParams["station"], platform: DeleteConnectionPathParams["platform"]}, TContext>
      
}